import React, { useState } from 'react'
import {
  Grid,
  Segment,
  Header,
  Divider,
  Modal,
  Button,
} from 'semantic-ui-react'
import i18next from 'i18next'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import tc_logo from 'assets/images/logos/circle-logo-green.svg'
import { PopInAnimation } from 'app/common/animations/pop-in/PopInAnimation'
import { advagymGreen } from 'app/protected/roles/util/colors'
import thunks from 'redux/actions/thunks/ProfileSettings'
import Badge from 'app/protected/roles/common/Badge'

interface WebSetting {
  name: string
  value: string
}

interface AnnouncementBannerProps {
  dismissed: boolean
  webSettings: WebSetting[]
  saveSetting: (settings: { webSettings: WebSetting[] }) => void
}

function AnnouncementBanner(props: Readonly<AnnouncementBannerProps>) {
  const { dismissed, webSettings, saveSetting } = props

  const initialState = { viewModal: !dismissed }
  const [{ viewModal }, setState] = useState(initialState)

  const doDismiss = () => {
    setState({ viewModal: false })
    let _webSettings = webSettings ? webSettings.slice() : []

    if (webSettings) {
      _webSettings = webSettings.filter(
        (s) => s.name !== 'dismiss_announcement_dialog'
      )
    }

    _webSettings.push({
      name: 'dismiss_announcement_dialog',
      value: 'dismissed',
    })

    saveSetting({ webSettings: _webSettings })
  }

  const headerView = () => {
    return (
      <Grid>
        <Grid.Row textAlign="center" style={{ paddingBottom: '0px' }}>
          <Grid.Column textAlign="center">
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Badge label={'TrainerConnect'} imageUrl={tc_logo} size="big" />
            </div>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row textAlign="center">
          <Grid.Column>
            <Header as="h2" icon>
              {i18next.t('important_announcement')}
            </Header>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }

  return (
    <PopInAnimation>
      <Divider hidden />
      <Modal size="small" open={viewModal}>
        <Modal.Content>
          {headerView()}
          <p style={{ paddingTop: '20px' }}>
            {i18next.t('important_announcement_text1')}
          </p>
          <p>{i18next.t('important_announcement_text2')}</p>
          <p>{i18next.t('important_announcement_text3')}</p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => doDismiss()} positive>
            {i18next.t('ok')}
          </Button>
        </Modal.Actions>
      </Modal>
      <Segment>
        <Grid>
          <Grid.Row>
            <Grid.Column textAlign="center" mobile="16" tablet="2" computer="2">
              <div className="flex justify-center pb-5 desktop:pb-0">
                <Badge label={'TrainerConnect'} imageUrl={tc_logo} size="big" />
              </div>
            </Grid.Column>
            <Grid.Column mobile="16" only="mobile">
              <Header textAlign="center" as="h4">
                {i18next.t('important_announcement')}
              </Header>
              <div>{i18next.t('important_announcement_text1')}</div>
              <Divider hidden />
              <Grid.Row style={{ paddingTop: '0px' }}>
                <Grid.Column textAlign="right" width="16">
                  <p
                    style={{
                      cursor: 'pointer',
                      color: advagymGreen,
                      fontWeight: 'bold',
                    }}
                    onClick={() => setState({ viewModal: true })}
                  >
                    {i18next.t('view_more')}
                  </p>
                </Grid.Column>
              </Grid.Row>
            </Grid.Column>

            <Grid.Column only="computer tablet" tablet="14" computer="14">
              <Header as="h4">{i18next.t('important_announcement')}</Header>
              <div>{i18next.t('important_announcement_text1')}</div>
              <Divider hidden />
              <Grid.Row style={{ paddingTop: '0px' }}>
                <Grid.Column textAlign="right" width="16">
                  <div
                    style={{
                      cursor: 'pointer',
                      color: advagymGreen,
                      fontWeight: 'bold',
                      paddingRight: '20px',
                    }}
                    onClick={() => setState({ viewModal: true })}
                  >
                    {i18next.t('view_more')}
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
      <Divider hidden />
    </PopInAnimation>
  )
}

const mapStateToProps = (state: any) => {
  const { data } = state.userReducer
  const { webSettingsOngoing } = state.profileSettingsReducer
  const { webSettings } = data
  const dismissed = webSettings
    ? webSettings.find((s: WebSetting) => s.name === 'dismiss_announcement_dialog')
    : null

  return {
    webSettings: webSettings ? webSettings : [],
    dismissed: webSettingsOngoing ? true : dismissed ? true : false,
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    saveSetting: (settings: { webSettings: WebSetting[] }) =>
      dispatch(thunks.saveWebsettings(settings)),
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AnnouncementBanner)
)
